export default __webpack_public_path__ + "static/media/GoodLuck.3b209dac.png";